import { type AuthUser } from "wasp/auth";
import DefaultLayout from "../layout/DefaultLayout";
import { useRedirectHomeUnlessUserIsAdmin } from "../useRedirectHomeUnlessUserIsAdmin";
import TasksView from "../onboardingTasks/TasksView";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import setDocumentTitle from "../../setDocumentTitle";
import FirstTimeUser from "../../views/DashboardFirstTimeUserView";
import PartiallyCompletedUser from "../../views/DashboardView/DashboardPartialCompletedUserView";
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import {
  updateCurrentUser,
  updateMiqCollection,
} from "wasp/client/operations";
import { shopifyBackendBaseUrl } from "./urls";
import { analytics } from "../../analytics";
import { useTranslation } from "../../i18n/hooks";

const AdminDashboardPage = ({ user }: { user: AuthUser }) => {
  useRedirectHomeUnlessUserIsAdmin({ user });
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    setDocumentTitle(t('sidebar.dashboard'));
  }, []);

  useEffect(() => {
    updateUserShopDomain();
  }, [navigate]);

  const {currentCollection} = useSelector((state: RootState) => state.user);

  async function updateUserShopDomain() {
    try {
      if(!currentCollection.collection) return;
      const shop = document.cookie
        .split("; ")
        .find((row) => row.startsWith("shop="));
      if (shop) {
        const shopDomain = shop.split("=")[1];
        await updateMiqCollection({ 
          id: currentCollection.collection?.id,
          miqShopifyDomain: shopDomain 
        }).then(
          async () => {
            document.cookie =
              "shop=;path=/;domain=" +
              window.location.hostname +
              ";expires=Thu, 01 Jan 1970 00:00:01 GMT";

            // Form oluştur ve submit et
            const form = document.createElement("form");
            form.method = "GET";
            form.action = `${shopifyBackendBaseUrl}/authorize`;

            const shopInput = document.createElement("input");
            shopInput.type = "hidden";
            shopInput.name = "shop";
            shopInput.value = shopDomain;

            const redirectInput = document.createElement("input");
            redirectInput.type = "hidden";
            redirectInput.name = "redirectPath";
            redirectInput.value = window.location.href;

            form.appendChild(shopInput);
            form.appendChild(redirectInput);
            document.body.appendChild(form);
            form.submit();
          }
        );
      }
    } catch (error) {
      console.error("Error updating user shop domain:", error);
    }
  }

  useEffect(() => {
    if(!currentCollection?.collection?.miqHasCompletedShopifyImport){
      analytics.sendDashboardFirstTimeViewedEvent({
        email: user.email ?? user.id,
      });
    }
  }, [currentCollection?.collection?.miqHasCompletedShopifyImport])

  const miqHasCompletedImport = currentCollection?.collection?.miqHasCompletedShopifyImport || currentCollection?.collection?.miqHasCompletedExcelImport;

  return (
    <DefaultLayout
      user={user}
      useWideLayout={miqHasCompletedImport ? true : false}
    >
      {miqHasCompletedImport ? <PartiallyCompletedUser /> : <FirstTimeUser />}
    </DefaultLayout>
  );
};

export default AdminDashboardPage;
